import { Link } from "react-router-dom";
import { Instagram, Globe, MessageCircle, MapPin } from "lucide-react";
import { LOGO, SITE } from "@/lib/site";
import { useConfig } from "@/context/ConfigContext";

export const Footer = () => {
    const { config, hasWhatsApp, waHref } = useConfig();
    const wa = waHref("Hola, quiero información sobre sus productos.");
    const igHandle = config.instagram || SITE.instagram;
    const igUrl = `https://instagram.com/${(igHandle || "").replace(/^@/, "")}`;
    const direccion = config.direccion || SITE.address;
    return (
        <footer id="contacto" className="hero-gradient text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <img src={LOGO.white} alt={SITE.name} className="h-12 mb-6" />
                        <p className="text-white/70 max-w-sm leading-relaxed">{SITE.slogan}.</p>
                        <div className="flex items-center gap-2 text-white/60 mt-5 text-sm">
                            <MapPin size={16} className="text-madera" /> {direccion}
                        </div>
                        {/* Identificación fiscal: obligatoria en la web y en las publicaciones */}
                        <p className="text-white/60 mt-3 text-sm">{SITE.razonSocial} · RIF {SITE.rif}</p>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-madera mb-5">Navegación</h4>
                        <ul className="space-y-3">
                            <li><Link to="/tienda" className="text-white/80 hover:text-madera transition-colors">Tienda</Link></li>
                            <li><Link to="/#categorias" className="text-white/80 hover:text-madera transition-colors">Categorías</Link></li>
                            <li><Link to="/#mayoreo" className="text-white/80 hover:text-madera transition-colors">Mayoreo</Link></li>
                            <li><Link to="/padmin" className="text-white/80 hover:text-madera transition-colors">Admin</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-madera mb-5">Contacto</h4>
                        <div className="space-y-4">
                            {hasWhatsApp ? (
                                <a href={wa} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-white/80 hover:text-madera transition-colors">
                                    <MessageCircle size={18} /> <span className="text-sm">WhatsApp</span>
                                </a>
                            ) : (
                                <Link to="/#presupuesto" data-testid="footer-whatsapp" className="flex items-center gap-3 text-white/80 hover:text-madera transition-colors">
                                    <MessageCircle size={18} /> <span className="text-sm">Escríbenos / presupuesto</span>
                                </Link>
                            )}
                            <a href={igUrl} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white/80 hover:text-madera transition-colors">
                                <Instagram size={18} /> <span className="text-sm">{igHandle}</span>
                            </a>
                            <a href={`https://${SITE.domain}`} className="flex items-center gap-3 text-white/80 hover:text-madera transition-colors">
                                <Globe size={18} /> <span className="text-sm">{SITE.domain}</span>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3">
                    <p className="text-xs text-white/50">© {new Date().getFullYear()} {SITE.name}. Todos los derechos reservados.</p>
                    <p className="text-xs text-white/50">Producción nacional · Venezuela 🇻🇪</p>
                </div>
            </div>
        </footer>
    );
};
